import type { ReviewAggregate, ReviewRecord } from "@lib/schema";

interface ReviewsListProps {
  reviews: ReviewRecord[];
  aggregate: ReviewAggregate | null;
}

export function ReviewsList({ reviews, aggregate }: ReviewsListProps) {
  return (
    <section className="reviews-list">
      <header>
        <h3>Reviews</h3>
        {aggregate ? (
          <p>
            Average rating: <strong>{aggregate.count ? aggregate.average.toFixed(1) : "N/A"}</strong> · {aggregate.count} total
          </p>
        ) : null}
      </header>
      {reviews.length ? (
        <ul>
          {reviews.map((review) => (
            <li key={review.id}>
              <div className="review-header">
                <strong>{review.title}</strong>
                <span>{"⭐".repeat(review.rating)}</span>
              </div>
              <p>{review.body}</p>
              <footer>
                <span>{review.user_name ?? "Anonymous"}</span>
                <time>{new Date(review.created_at).toLocaleDateString()}</time>
              </footer>
            </li>
          ))}
        </ul>
      ) : (
        <p>No reviews yet. Be the first to share your experience!</p>
      )}
    </section>
  );
}
